const map = {
	"./ar-AR.json": 4555,
	"./be-BY.json": 6819,
	"./bn-BD.json": 6143,
	"./cs-CZ.json": 594,
	"./da-DK.json": 8489,
	"./de-DE.json": 6223,
	"./el-GR.json": 7707,
	"./en-US.json": 3516,
	"./es-ES.json": 4289,
	"./fa-IR.json": 2589,
	"./fi-FI.json": 2103,
	"./fr-FR.json": 7889,
	"./hr-HR.json": 4961,
	"./hu-HU.json": 1055,
	"./in-ID.json": 8837,
	"./it-IT.json": 8036,
	"./iw-IL.json": 6492,
	"./ja-JP.json": 388,
	"./km-KH.json": 470,
	"./ko-KR.json": 9254,
	"./ms-MY.json": 5199,
	"./nb-NO.json": 146,
	"./nl-NL.json": 7797,
	"./pl-PL.json": 6493,
	"./pt-PT.json": 1821,
	"./ro-RO.json": 6455,
	"./ru-RU.json": 4327,
	"./sr-RS.json": 4657,
	"./sv-SE.json": 7878,
	"./th-TH.json": 8869,
	"./tl-PH.json": 237,
	"./tr-TR.json": 2433,
	"./uk-UA.json": 495,
	"./ur-PK.json": 9321,
	"./vi-VN.json": 3658,
	"./zh-CN.json": 5054,
	"./zh-TW.json": 5034
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9275;